export { ControlsPanel, type ControlsPanelProps } from './ControlsPanel';
